var map = {
	"./cafes-icon.svg": "9543",
	"./gyms-icon.svg": "d896",
	"./metro-icon.svg": "1eb1",
	"./parking-icon.svg": "f77f",
	"./shops-icon.svg": "0cbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "faf0";